<template>
  <div class='core'>
    <div class='layui-fluid'>
      <pub-search
        :search-type="'add'"
        :tableObj='tableObj'
        :searchConfig='searchConfig'
        exportType="1"
        @exportExcel="exportExcel"
      >
        <template>
          <button class='layui-btn' title='新增店长' @click='addStoreManagerOnClick()'>
            <i class='layui-icon'>&#xe624;</i>新增店长
          </button>
          <button class="layui-btn" title="导入" @click="importExcel()">
                <span style="display:none" id="importWarpper">
                  <form enctype="multipart/form-data" style="margin-top: 20px;margin-bottom:10px;">
                      <div style="margin-left: 8.33333333%;">
                          <input type="file" id="file" accept=".xls,.xlsx"/>
                         <div style="margin-top:10px;padding-top:5px">
                          <a style="cursor:pointer;color: blue" href="/static/template/店长信息模板.xlsx"
                             class="btn btn-default btn-xs"><i class="fa fa-file-excel-o"></i> 下载模板</a>
                        </div>
                          <font color="red" style="margin-top:10px;display: block;">
                            提示：仅允许导入“xls”或“xlsx”格式文件！
                          </font>
                      </div>
                  </form>
                </span>
            <i class="layui-icon">&#xe624;</i>
            导入
          </button>
        </template>
      </pub-search>
      <layui-table
        ref='storeManagerMainViewRef'
        table-name='YW_STORE_MANAGER'
        :page-size='20'
        :page-range='6'
        :page-options='[10, 20, 50, 100]'
        :skin="'line'"
        :sort="['CREATE_TIME:DESC']"
        @table-event-edit='updateStoreManagerOnClick($event)'
        @table-event-check="check($event)"
        @table-event-del='$refs.storeManagerMainViewRef.delRows($event.data)'
      >
        <div>
          <div checkbox='true' align='center' fixed='left' width='60'></div>
          <layui-tableconfig :config='mdTableList'></layui-tableconfig>
          <div rowspan='3' align='center' fixed='right' title='操作' width='130'>
            <script type='text/html' v-pre>
              <a class=" layui-btn-xs" lay-event="check" style="cursor:pointer">查看</a>
              <a class='layui-btn-xs' lay-event='edit'>编辑</a>
              <a class='layui-btn-xs layui-btn-xs-danger' lay-event='del'>删除</a>
            </script>
          </div>
        </div>
      </layui-table>
    </div>
  </div>
</template>
<script>
import "../../../utils/map/css/core.css"

export default {
  name: 'storeManagerManage',
  data () {
    return {
        mdTableList: [
          { field: 'STORE_MANAGER_CODE', title: '店长编号', width: 250 },
          { field: 'STORE_MANAGER_NAME', title: '店长名称', width: 200},
          { field: 'CUSTOMER_STORE_EXT_NAMES', title: '门店名称', width: 250},
          { field: 'STORE_MANAGER_PHONE', title: '联系方式', width: 250},
          { field: 'WECHAT_ID', title: '微信号', width: 250},
          { field: 'CREATE_TIME', title: '创建时间', width: 200, sort: true},
          { field: 'MEMO', title: '备注' },
        ],
        tableObj: {
            checkedRows: 0,
            queryObject: {}
        },
        searchConfig: {
          basic: [
            {
              TYPE: 'input',
              WIDTH: 260,
              FIELD: 'STORE_MANAGER_CODE:2, WECHAT_ID:2, STORE_MANAGER_NAME:2, CUSTOMER_STORE_EXT_NAMES:2, STORE_MANAGER_PHONE:2',
              PLACEHOLDER: '请输入查询条件'
            }
          ],
          advanced: [
            { TYPE:'input', NAME: '店长编号 :', FIELD:'STORE_MANAGER_CODE:2', PLACEHOLDER: '请输入店长编号'},
            { TYPE:'input', NAME: '店长名称 :', FIELD:'STORE_MANAGER_NAME:2', PLACEHOLDER: '请输入店长名称'},
            { TYPE:'input', NAME: '门店名称 :', FIELD:'CUSTOMER_STORE_EXT_NAMES:2', PLACEHOLDER: '请输入门店名称'},
            { TYPE:'input', NAME: '联系方式 :', FIELD:'STORE_MANAGER_PHONE:2', PLACEHOLDER: '请输入联系方式'},
            { TYPE:'input', NAME: '微信号 :', FIELD:'WECHAT_ID:2', PLACEHOLDER: '请输入微信号'},
            { TYPE:'date', NAME: '创建时间 :', FIELD:'CREATE_TIME:2', PLACEHOLDER: '请选择创建时间'},
          ],
          showBatch: false
        },
    }
  },
  mounted(){
    this.tableObj = this.$refs.storeManagerMainViewRef;
  },
  methods: {
    addStoreManagerOnClick() {
      this.baseComponent.smartLoadComponent('storeManagerMngForm', {tableObj: this.tableObj, formType: 'add', title: '新增店长'});
    },

    updateStoreManagerOnClick($event) {
      this.baseComponent.smartLoadComponent('storeManagerMngForm', {editRow: $event.data, tableObj: this.tableObj, formType: 'edit', title: '编辑店长'});
    },

    check($event){
      this.baseComponent.smartLoadComponent('storeManagerMngForm', {editRow: $event.data, tableObj: this.tableObj, formType: 'browser', title: '查看店长'})
    },

    exportExcel() {
      let token = this.security.getToken()
      this.exportUrl = process.env.API_HOST + '/yw/storeManager/exportStoreManagerData'

      let formHtml = '<form  method="post" action="' + (this.exportUrl) + '" style="display:none;" accept-charset="UTF-8">'
      formHtml += '<input type="hidden" name="token"' + '" value="' + token + '">'
      formHtml += '</form>'

      $(formHtml).appendTo($('body')).submit()
    },
    importExcel(){
      var that = this;
      this.layui.layer.open({
        type: 1,
        area: ['400px', '230px'],
        fix: false,
        //不固定
        maxmin: true,
        shade: 0.3,
        title: '上传数据',
        content: $('#importWarpper').html(),
        btn: ['<i class="fa fa-check"></i> 导入', '<i class="fa fa-remove"></i> 取消'],
        // 弹层外区域关闭
        shadeClose: true,
        btn1: function(index, layero){
          var file = layero.find('#file').val();
          if (file == '' || (!file.endsWith('.xls') && !file.endsWith('.xlsx'))){
            that.layer.openAlert("请选择后缀为 “xls”或“xlsx”的文件。");
            return false;
          }
          var index = layer.load(2, {shade: false});
          var formData = new FormData();
          formData.append("file", layero.find('#file')[0].files[0]);

          $.ajax({
            url: process.env.API_HOST + '/newData/import/storeManager?token=' + that.security.getToken(),
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            success: function (result) {
              debugger
              console.log("result/////", result);
              layer.closeAll();
              if(result.errorMsg){
                that.layer.openAlert(result.errorMsg);
                return;
              }
              result = result.result;
              layer.close(index);
              if(result == ""){
                that.$nextTick(()=> {
                  that.layer.openSuccess("导入成功");
                  that.tableObj.load();
                });
              }
            },
            error: function(err){
              layer.close(index);
            }
          });
        }
      });
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/person/storeManagerManage/index.vue